<template>
  <v-card>
    
    <v-toolbar class="hxblue dark" dark :height="50" card>
      <v-toolbar-title>Rules</v-toolbar-title>
      <v-spacer />
      <v-btn color="success" fab small dark @click="addRule()">
        <v-icon>add</v-icon>
      </v-btn>
      <v-btn color="success" fab small dark @click="addGroup()">
        +
        <v-icon>group</v-icon>
      </v-btn>
      <v-btn color="error" v-if="!isFirst" fab small dark @click="deleteSelf()">
        <v-icon>close</v-icon>
      </v-btn>
    </v-toolbar>
    <v-card-text class="ml-0 px-0 py-0">
      <v-layout row wrap>
        <v-flex xs12 :class="{'and-or-first':isFirst}">
          <v-layout row>
            <v-flex class="and-or hxblue dark" @click="isAnd=!isAnd">
              <div>{{isAnd?'AND':'OR'}}</div>
            </v-flex>
            <v-flex pa-0 mr-1 xs12 pt-1>
              <v-layout row>
                <v-flex xs12>
                  <v-layout row wrap>
                    <v-flex xs12 pr-3>
                      <template v-for="(rule, index) in rules">
                        <v-flex xs12 :key="rule">
                          <rule ref="rules" :options="options" @delete-rule="deleteRule(index)"></rule>
                        </v-flex>
                        <v-divider :key="index"></v-divider>
                      </template>
                    </v-flex>

                    <v-flex xs12 v-for="(group, index) in groups" :key="group" ml-1 mb-1>
                      <operator ref="groups" :options="options" @delete-group="deleteGroup(index)"></operator>
                    </v-flex>
                  </v-layout>
                </v-flex>
              </v-layout>
            </v-flex>
            <v-flex class="and-or small hxblue dark" @click="isAnd=!isAnd">
            </v-flex>
          </v-layout>
        </v-flex>
      </v-layout>
    </v-card-text>
    <v-footer class="hxblue dark foot small" dark></v-footer>
  </v-card>
</template>

<script>
/* tslint:disable */

import Rule from "./Rule";
export default {
  name: "operator",
  components: {
    Rule
  },
  props: {
    options: {
      type: Object,
      required: true
    },
    isFirst: {
      type: Boolean,
      default: false
    }
  },
  created() {
    this.addRule();
  },
  data() {
    return {
      isAnd: true,
      groups: [],
      rules: []
    };
  },
  methods: {
    clickAnd() {
      this.isAnd = true;
    },
    clickOr() {
      this.isAnd = false;
    },
    addRule() {
      const id = this.generateId();
      this.rules.push(id);
    },
    addGroup() {
      const id = this.generateId();
      this.groups.push(id);
    },
    deleteSelf() {
      this.$emit("delete-group");
    },
    deleteRule(index) {
      this.rules.splice(index, 1);
    },
    deleteGroup(index) {
      this.groups.splice(index, 1);
    },
    queryFormStatus() {
      const query = {};
      const rules = this.$refs.rules || {};
      const groups = this.$refs.groups || {};
      let i;
      let j;
      query["condition"] = this.isAnd ? "AND" : "OR";
      query["rules"] = [];
      for (i = 0; i < rules.length; i++) {
        query.rules.push(rules[i].queryFormStatus());
      }
      for (j = 0; j < groups.length; j++) {
        query.rules[query.rules.length] = groups[j].queryFormStatus();
      }
      return query;
    },
    fillFormStatus(data) {
      let i;
      let len;
      const group = this;
      group.rules = [];
      group.groups = [];
      if (data) {
        group.isAnd = /and/i.test(data.condition);
        len = data.rules.length;
        for (i = 0; i < len; i++) {
          if (data.rules[i].condition) {
            group.groups.push(group.generateId());
            ((i, index) =>{
              group.$nextTick(() =>{
                group.$refs.groups[index].fillFormStatus(data.rules[i]);
              });
            })(i, group.groups.length - 1);
          } else {
            group.rules.push(group.generateId());
            ((i, index) =>{
              group.$nextTick(() =>{
                group.$refs.rules[index].fillRuleStatus(data.rules[i]);
              });
            })(i, group.rules.length - 1);
          }
        }
      }
    },
    generateId() {
      return "xxxxxxxxxxxxxxxx".replace(/[xy]/g, (c) => {
        const r = (Math.random() * 16) | 0
        const v = c === "x" ? r : (r & 0x3) | 0x8;
        return v.toString(16);
      });
    }
  }
};
</script>

<style lang="scss">
.and-or {
  cursor: pointer;
  max-width: 20px;
  min-width: 20px;
  div {
    position: relative;
    top: 50%;
    left: 50%;
    transform: translateX(-50%) translateY(-50%) rotate(-90deg);
    font-size: 18px;
    font-weight: lighter;
  }
}
.and-or.small{
  max-width: 10px;
  min-width: 10px;
}
.actions {
  background: rgb(19, 190, 209);
}
.foot.small{
  min-height: 10px;
  max-height: 10px;
}
</style>